import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const Section = ({ title, children }) => (
  <section className="mb-8">
    <h2 className="mb-3 text-lg font-bold text-[#0A192F]">{title}</h2>
    <div className="space-y-2 text-sm leading-7 text-slate-600">{children}</div>
  </section>
);

export default function PrivacyPage() {
  const navigate = useNavigate();
  const [contactEmail, setContactEmail] = useState('');

  useEffect(() => {
    axios.get(`${API}/platform/settings`).then((res) => {
      if (res.data?.contact_email) setContactEmail(res.data.contact_email);
    }).catch(() => {});
  }, []);

  return (
    <div dir="rtl" className="min-h-screen bg-slate-50" data-testid="privacy-page">
      <header className="border-b border-slate-200 bg-white px-6 py-4">
        <div className="mx-auto flex max-w-3xl items-center justify-between">
          <button onClick={() => navigate(-1)} data-testid="privacy-back-btn" className="text-sm font-semibold text-teal-600 hover:underline">
            ← رجوع
          </button>
          <span className="font-bold text-[#0A192F]">تسيار</span>
        </div>
      </header>

      <main className="mx-auto max-w-3xl px-6 py-12">
        <h1 className="mb-2 text-2xl font-bold text-[#0A192F]" data-testid="privacy-title">سياسة الخصوصية</h1>
        <p className="mb-8 text-xs text-slate-400">آخر تحديث: {new Date().toLocaleDateString('ar-SA')}</p>

        <Section title="1. مقدمة">
          <p>
            توضح هذه السياسة كيفية جمع منصة «تسيار» لإدارة الأندية والأكاديميات الرياضية للبيانات واستخدامها وحمايتها،
            سواء كنت مسؤولاً في منشأة مسجّلة على المنصة أو مستخدماً (لاعباً، ولي أمر، موظفاً، أو مدرباً) تتعامل بياناته
            مع منشأة تستخدم المنصة.
          </p>
        </Section>

        <Section title="2. عزل بيانات كل منشأة">
          <p>
            تعتمد المنصة بنية متعددة المنشآت (Multi-Tenant) بحيث تكون بيانات كل نادٍ أو أكاديمية معزولة بالكامل عن بيانات
            أي منشأة أخرى مسجّلة على المنصة. لا يمكن لمستخدمي منشأة الوصول إلى بيانات منشأة أخرى بأي شكل.
          </p>
        </Section>

        <Section title="3. البيانات التي نجمعها">
          <p>تشمل البيانات التي قد تُخزَّن على المنصة بحسب استخدام كل منشأة لها:</p>
          <ul className="list-inside list-disc space-y-1">
            <li>بيانات حساب المستخدم (الاسم، اسم المستخدم، الدور الوظيفي).</li>
            <li>بيانات اللاعبين والموظفين التي تُدخلها المنشأة (الاسم، تاريخ الميلاد، رقم الجوال، صورة الملف الشخصي إن وُجدت).</li>
            <li>بيانات الحضور والانصراف والأداء الرياضي والمباريات.</li>
            <li>بيانات الاشتراكات والمعاملات المالية الخاصة بالمنشأة.</li>
          </ul>
        </Section>

        <Section title="4. كيفية استخدام البيانات">
          <p>
            تُستخدم البيانات المذكورة أعلاه فقط لتقديم خدمات المنصة للمنشأة التي أدخلتها: إدارة اللاعبين والموظفين،
            تتبّع الحضور والأداء، إصدار التقارير، وإدارة الاشتراكات والمدفوعات الداخلية للمنشأة. لا تُستخدم بيانات
            منشأة لأي غرض تسويقي أو تجاري خارج نطاق تلك المنشأة.
          </p>
        </Section>

        <Section title="5. مشاركة البيانات">
          <p>
            لا تبيع المنصة أو تشارك بيانات المستخدمين مع أي طرف ثالث لأغراض تسويقية. تتم معالجة البيانات فقط عبر
            مزوّدي الاستضافة والبنية التقنية اللازمين لتشغيل المنصة.
          </p>
        </Section>

        <Section title="6. أمن البيانات">
          <p>
            تُحفظ كلمات المرور بصيغة مُشفّرة، ويعتمد الوصول إلى النظام على صلاحيات محددة حسب دور كل مستخدم داخل
            منشأته (مدير، مدرب، موظف مالية، إلخ)، بحيث يرى كل مستخدم فقط البيانات المصرَّح له بالوصول إليها.
          </p>
        </Section>

        <Section title="7. حقوق المستخدم">
          <p>
            يحق لأي مستخدم طلب الاطلاع على بياناته أو تعديلها أو حذفها من خلال مسؤول المنشأة التي يتبع لها حسابه،
            حيث تبقى إدارة الحسابات الفردية مسؤولية مدير كل منشأة.
          </p>
        </Section>

        <Section title="8. التواصل">
          <p>
            لأي استفسار بخصوص هذه السياسة{contactEmail ? <> يمكن التواصل عبر <span dir="ltr" className="font-semibold">{contactEmail}</span></> : '، يرجى التواصل مع مدير المنشأة الخاصة بك أو الجهة المشغّلة للمنصة'}.
          </p>
        </Section>
      </main>
    </div>
  );
}
